
import React from 'react'
import SEO from '../components/seo'
import ProductGrid from '../components/ProductGrid'

const PrintPage = () => (
  <>
    <SEO
      title="Shop"
      description="Ellington Hammond's shop"
    />
    <ProductGrid />


  </>
)

export default PrintPage
